var $697f8e526692bd95$exports = {};
$697f8e526692bd95$exports = {
    "alert": `\u{41F}\u{440}\u{435}\u{434}\u{443}\u{43F}\u{440}\u{435}\u{436}\u{434}\u{435}\u{43D}\u{438}\u{435}`,
    "dismiss": `\u{41F}\u{440}\u{43E}\u{43F}\u{443}\u{441}\u{442}\u{438}\u{442}\u{44C}`
};


export {$697f8e526692bd95$exports as default};
//# sourceMappingURL=ru-RU.module.js.map
